import {AppEntities} from "../../../config/entities";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import {useState} from "react";
import {NFLookupSearchBaseDocument} from "./NFLookupSearchBaseDocument";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    accountId?: string;
}

export const NFLookupBaseDocuments = ({
                                          title,
                                          fieldName,
                                          required,
                                          showBorder,
                                      }: IProps) => {
    const [selectedCatalog, setSelectedCatalog] = useState(false);
    const [searchText, setSearchText] = useState("");

    const joinedTitle = searchText.replace(/[\s\W]+/g, "");

    const selectedEntity: any =
        AppEntities[joinedTitle as keyof typeof AppEntities];

    const loadData = async (searchText: string | undefined) => {
        return await selectedEntity.getDataService().GetAll(searchText);
    };

    return (
        <>
            {selectedCatalog ? (
                selectedEntity.getLookupComponent({
                    fieldName: fieldName,
                    title: selectedEntity.title,
                    setSelectedCatalog: setSelectedCatalog,
                })
            ) : (
                <NFLookupSearchBaseDocument
                    fieldName={fieldName}
                    title={title}
                    entity={selectedEntity}
                    serverData={loadData}
                    required={required}
                    showBorder={showBorder}
                    selectedCatalog={selectedCatalog}
                    setSelectedCatalog={setSelectedCatalog}
                    searchText={searchText}
                    setSearchText={setSearchText}
                >
                    <NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>
                    <NFLookupCatalogColumn fieldName={"name"} caption={"Name"}/>
                    <NFLookupCatalogColumn fieldName={"tin"} caption={"TIN"}/>
                </NFLookupSearchBaseDocument>
            )}
        </>
    );
};
